import React, {useState} from "react"
import { customDateFormat, drawTableBJPointCell, drawTableTitleCell, drawTableArticleType, formatNumber, string, getPointCellInfo } from '../../helper/common'
import TableCell from '../control/table/table_cell'
import strings from "../../lang/strings";
//전체데이터 BJ 분석데이터
export const BjTableRows = ({ header, data, onTitleClick, onBJClick, rowClick=true }) => {
    const [hoveredRowIndex, setHoveredRowIndex] = useState(null);
    return data.map((info, index) => {
        return (
          <div
            key={index}
            className={`tb-row  ${rowClick? "clickable-row-highlight cursor-point" :  hoveredRowIndex === index ? 'hovered-row' : ''}`} onClick={() => {rowClick && onTitleClick?.(info)} }
          >
            <TableCell
              value={null}
              className={header[0].class}
              center={header[0].center}
              child={drawTableArticleType(info.dat_cate, info.dat_is_betting == 1)}
            />
            <TableCell
              onClick={() => { !rowClick && onBJClick?.(info)}}
              value={info.mb_nick}
              className={`${header[1].class} ${rowClick ? "" : "hover-text-accent cursor-point"}`}
              center={header[1].center}
              child={null}
            />

            <TableCell
              value={customDateFormat(info.dat_start)}
              className={header[2].class}
              center={header[2].center}
              child={null}
            />

            <TableCell
              onClick={() => { !rowClick && onTitleClick?.(info) }}
              value={info.dat_title}
              className={`${header[3].class} ${rowClick ? "hover-text-accent-child" : "hover-text-accent cursor-point"}`}
              center={header[3].center}
              child={drawTableTitleCell(info.dat_title, info.data_new)}
              onMouseEnter={() => !rowClick && setHoveredRowIndex(index)}
              onMouseLeave={() => !rowClick && setHoveredRowIndex(null)}
            />
            <TableCell
              value={customDateFormat(info.dat_createdat)}
              className={header[4].class}
              center={header[4].center}
              child={null}
            />
            <TableCell
              value={getPointCellInfo(info).value}
              color={getPointCellInfo(info).color}
              className={header[5].class}
              center={header[5].center}
              child={null}
            />
          </div>
        )
    })
};

export const DailyTableRows = ({
    header,
    data,
    onTitleClick,
    onBJClick,
    rowClick = true,
}) => {
    const [hoveredRowIndex, setHoveredRowIndex] = useState(null);

    return data.map((info, index) => (
        <div
            key={index}
            className={`tb-row ${
                rowClick
                    ? 'clickable-row-highlight cursor-point'
                    : hoveredRowIndex === index
                    ? 'hovered-row'
                    : ''
            }`}
            onClick={() => {
                rowClick && onTitleClick?.(info, info.dat_po);
            }}
        >
            {/* 회차/경기정보 */}
            <TableCell
                value={`${info.dat_s_year}${strings.year} ${info.dat_s_round}${strings.times}`}
                className={header[0].class}
                center={header[0].center}
                child={null}
            />

            {/* BJ명 */}
            <TableCell
                onClick={() => {
                    !rowClick && onBJClick?.(info);
                }}
                value={info.mb_nick}
                className={`${
                    header[1].class
                } ${rowClick ? '' : 'hover-text-accent cursor-point'}`}
                center={header[1].center}
                child={null}
            />

            {/* 경기일시 */}
            <TableCell
                value={customDateFormat(info.dat_start)}
                className={header[2].class}
                center={header[2].center}
                child={null}
            />

            {/* 제목 */}
            <TableCell
                onClick={() => {
                    !rowClick && onTitleClick?.(info, info.dat_po);
                }}
                value={info.dat_title}
                className={`${
                    header[3].class
                } ${rowClick ? 'hover-text-accent-child' : 'hover-text-accent cursor-point'}`}
                center={header[3].center}
                child={drawTableTitleCell(info.dat_title, info.data_new)}
                onMouseEnter={() => !rowClick &&  setHoveredRowIndex(index)}
                onMouseLeave={() => !rowClick &&  setHoveredRowIndex(null)}
            />

            {/* 업로드일시 */}
            <TableCell
                value={customDateFormat(info.dat_createdat)}
                className={header[4].class}
                center={header[4].center}
                child={null}
            />

            {/* 구매 */}
            <TableCell
                value={
                    getPointCellInfo(info).value
                }
                color={
                    getPointCellInfo(info).color
                }
                className={header[5].class}
                center={header[5].center}
                child={null}
            />
        </div>
    ));
};



// const GameTableRows = ({ data, onRowClick }) => {
//     return data.map((info, index) => (
//         <div key={index} className="tb-row clickable-row-highlight cursor-point" onClick={() => onRowClick(info, info.dat_po)}>
//             <TableCell value={`${info.dat_s_year}${strings.year} ${info.dat_s_round}${strings.times}`} className={tbGameHeaders[0].class} center={tbGameHeaders[0].center} />
//             <TableCellGameCate icon={info.sk_icon} name={info.sk_name} className={`${tbGameHeaders[1].class} d-flex`} center={tbGameHeaders[1].center} />
//             <TableCell value={customDateFormat(info.dat_start)} className={tbGameHeaders[2].class} center={tbGameHeaders[2].center} />
//             <TableCell value={`${info.home_name} : ${info.away_name}`} className={tbGameHeaders[3].class} center={tbGameHeaders[3].center} />
//             <TableCell value={info.dat_title} className={`${tbGameHeaders[4].class} hover-text-accent`} center={tbGameHeaders[4].center} child={drawTableTitleCell(info.dat_title, info.data_new)} />
//             <TableCell value={info.mb_nick} className={tbGameHeaders[5].class} center={tbGameHeaders[5].center} />
//             <TableCell value={info.is_purchased == 1 ? strings.free_price : (info.is_readable == 0 ? strings.disable_buy : strings.no_buy)}
//                 color={info.is_purchased == 1 ? null : (info.is_readable == 0 ? strings.disable_buy_color : strings.no_buy_color)}
//                 className={tbGameHeaders[6].class} center={tbGameHeaders[6].center} child={drawTableBJPointCell(info.dat_po, info.dat_po, info.is_purchased, info.is_readable)} />
//         </div>
//     ));
// };


// const AnalystTableRows = ({ data, onRowClick }) => {
//     return data.map((info, index) => (
//         <div key={index} className="tb-row clickable-row-highlight cursor-point" onClick={() => onRowClick(info, info.dat_po)}>
//             <TableCell value={`${info.dat_s_year}${strings.year} ${info.dat_s_round}${strings.times}`} className={tbAnalystHeaders[0].class} center={tbAnalystHeaders[0].center} />
//             <TableCell value={customDateFormat(info.dat_start)} className={tbAnalystHeaders[1].class} center={tbAnalystHeaders[1].center} />
//             <TableCellGameCate icon={info.sk_icon} name={info.sk_name} className={`${tbAnalystHeaders[2].class} d-flex`} center={tbAnalystHeaders[2].center} />
//             <TableCell value={info.dat_title} className={`${tbAnalystHeaders[3].class} hover-text-accent`} center={tbAnalystHeaders[3].center} child={drawTableTitleCell(info.dat_title, info.data_new)} />
//             <TableCell value={info.mb_nick} className={tbAnalystHeaders[4].class} center={tbAnalystHeaders[4].center} />
//             <TableCell value={info.is_purchased == 1 ? strings.free_price : (info.is_readable == 0 ? strings.disable_buy : strings.no_buy)}
//                 color={info.is_purchased == 1 ? null : (info.is_readable == 0 ? strings.disable_buy_color : strings.no_buy_color)}
//                 className={tbAnalystHeaders[5].class} center={tbAnalystHeaders[5].center} child={drawTableBJPointCell(info.dat_po, info.dat_po, info.is_purchased, info.is_readable)} />
//         </div>
//     ));
// };

// // 전체데이터 데일리스폐셜
// const DailyTableRows = ({ data, onRowClick }) => {
//     return data.map((info, index) => (
//         <div key={index} className="tb-row clickable-row-highlight cursor-point" onClick={() => onRowClick(info, info.dat_po)}>
//             <TableCell value={`${info.dat_s_year}${strings.year} ${info.dat_s_round}${strings.times}`} className={tbDailyHeaders[0].class} center={tbDailyHeaders[0].center} />
//             <TableCellGameCate icon={info.sk_icon} name={info.sk_name} className={`${tbDailyHeaders[1].class} d-flex`} center={tbDailyHeaders[1].center} />
//             <TableCell value={customDateFormat(info.dat_start)} className={tbDailyHeaders[2].class} center={tbDailyHeaders[2].center} />
//             <TableCell value={info.dat_title} className={`${tbDailyHeaders[3].class} hover-text-accent`} center={tbDailyHeaders[3].center} child={drawTableTitleCell(info.dat_title, info.data_new)} />
//             <TableCell value={info.mb_nick} className={tbDailyHeaders[4].class} center={tbDailyHeaders[4].center} />
//             <TableCell value={info.is_purchased == 1 ? strings.free_price : (info.is_readable == 0 ? strings.disable_buy : strings.no_buy)}
//                 color={info.is_purchased == 1 ? null : (info.is_readable == 0 ? strings.disable_buy_color : strings.no_buy_color)}
//                 className={tbDailyHeaders[5].class} center={tbDailyHeaders[5].center} child={drawTableBJPointCell(info.dat_po, info.dat_po, info.is_purchased, info.is_readable)} />
//         </div>
//     ));
// };

// export {BjTableRows, AnalystTableRows, DailyTableRows, GameTableRows}
